<template>
  <div class="address">
    <div v-if="parentRoute === 'delivery'">
      <input-label :text="$t('address.isKnownAddress.label')" />
      <input-selector data-cy="is-known-address-option"
                      v-model="isKnownAddress" :options="isKnownAddressOptions" />
    </div>
    <auto-complete-address
      v-if="parentRoute !== 'delivery' || isKnownAddress !== null"
      :auto="displayAutoCompleteAddress"
      v-model="addressSync"
      :display-street="displayStreet"
      :label="$t(`address.autocomplete.label.${parentRoute}`)"
      :secondaryLabel="confirmAddressLabel"
      @update:city="citySync = $event"
      @update:postal="postalSync = $event"
      @update:street="streetSync = $event" >
    </auto-complete-address>
  </div>
</template>

<script>
import InputSelector from '@/components/utils/InputSelector.vue';
import InputLabel from '@/components/utils/InputLabel.vue';
import AutoCompleteAddress from '../utils/AutoCompleteAddress.vue';

export default {
  name: 'Address',
  components: {
    AutoCompleteAddress,
    InputSelector,
    InputLabel,
  },
  data() {
    return {
      autocomplete: null,
      isKnownAddress: null,
    };
  },
  computed: {
    displayAutoCompleteAddress() {
      return (this.parentRoute === 'loading' && this.isStreetKnown === false)
        || (this.parentRoute === 'delivery' && this.isKnownAddress === true && this.isStreetKnown === false);
    },
    addressSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/address`];
      },
      set(address) {
        if (Object.keys(address).length > 0) {
          this.$store.commit(`${this.parentRoute}Store/SET_ADDRESS`, address);
        }
      },
    },
    streetSync: {
      get() {
        return this.addressSync.street;
      },
      set(street) {
        this.$store.commit(`${this.parentRoute}Store/SET_STREET`, street);
      },
    },
    postalSync: {
      get() {
        return this.addressSync.postal;
      },
      set(postal) {
        this.$store.commit(`${this.parentRoute}Store/SET_POSTAL`, postal);
      },
    },
    citySync: {
      get() {
        return this.addressSync.city;
      },
      set(city) {
        this.$store.commit(`${this.parentRoute}Store/SET_CITY`, city);
      },
    },
    isKnownAddressOptions() {
      return [
        {
          value: true,
          label: this.$t('base.yes'),
        },
        {
          value: false,
          label: this.$t('base.no'),
        },
      ];
    },
    parentRoute() {
      return this.$route.path.split('/')[1];
    },
    displayStreet() {
      return this.parentRoute !== 'delivery' || this.isKnownAddress;
    },
    isStreetKnown() {
      return this.streetSync !== `${this.citySync}, France` && this.streetSync !== '-';
    },
    confirmAddressLabel() {
      return this.isKnownAddress
        ? this.$t(`address.autocomplete.secondaryLabel.${this.parentRoute}`)
        : this.$t(`address.autocomplete.unknownLabel.${this.parentRoute}`);
    },
  },
  methods: {
    updateKnownAddress(streetValue) {
      if (streetValue !== undefined
        && streetValue !== null
        && streetValue.length >= 0 && this.isStreetKnown) {
        this.isKnownAddress = true;
      } else if (streetValue === '-') {
        this.isKnownAddress = false;
      }
    },
  },
  created() {
    this.updateKnownAddress(this.streetSync);
  },
  watch: {
    isKnownAddress(newValue) {
      this.$store.commit('deliveryStore/SET_IS_KNOW_ADDRESS', newValue);
      if (!newValue) {
        this.$store.commit('deliveryStore/SET_TYPES_LOGEMENT', 'DGTS_LOG_UNDEFINED');
        this.streetSync = '-';
      } else if (!this.streetSync) {
        this.streetSync = '';
      }
    },
    streetSync(value) {
      this.updateKnownAddress(value);
    },
  },
};
</script>
